import {
	createContext,
	FC,
	ReactNode,
	useContext,
	useEffect,
	useState,
} from 'react';

type Props = {
	children: ReactNode;
};
type ContextType = typeof OT;

const Context = createContext<ContextType>(undefined as unknown as ContextType);

const OpenTokProvider: FC<Props> = ({ children }: Props) => {
	const [OpenTok, setOpenTok] = useState<typeof OT>();

	useEffect(() => {
		import('@opentok/client').then((result) => {
			setOpenTok(result);
			// OT.setLogLevel(OT.DEBUG);
		});
	}, []);

	return OpenTok ? (
		<Context.Provider value={OpenTok}>{children}</Context.Provider>
	) : null;
};

export const useOpenTokContext = (): ContextType => useContext(Context);

export default OpenTokProvider;
